import { useMemo } from "react";
import { getLogger } from "../utils/ermineLoggerUtils";

export const useGetLogger = () => {
    return useMemo(() => getLogger(), []);
};
